<ng-container *ngIf="checklists?.length > 0">
  <div class="customTree pb-20" *DemoAccount="'Default'; let isDemo=isDemo" [tourStep]="tourStep">
    <ng-container *ngFor="let ch of checklists; let i = index">

      <zen-accordions>
        <zen-accordion #accordion extraClasses="rounded-sm mt-px">
          <ng-container head>
            <div class="flex flex-row items-center justify-between h-12 px-5 btn">
              <div (click)="$event.stopPropagation();companyClick(isDemo, i, ch)"
                class="flex flex-row items-center gap-2">
                <i class="text-xl"
                  [ngClass]="!ch.isChecked?'fa-regular fa-square text-zen':'fa-solid fa-square-check text-exp'"></i>
                <h5>{{ extractNameLanguage(ch.name) }}</h5>

              </div>
              <!-- <mat-checkbox [disabled]="isDemo && i >= 2" class="comment-checkbox" [ngModel]="ch.isChecked"
                (ngModelChange)="isDemo &&i >= 2?'':ch.isChecked = $event;isDemo &&i >= 2?'':checklistCheckedChanged($event,ch)">
                {{ extractNameLanguage(ch.name) }}
              </mat-checkbox> -->

              <i class="fa-regular fa-angle-down transform transition-all"
                [ngClass]="{'rotate-180':accordion.active}"></i>
            </div>
          </ng-container>
          <ng-container body>
            <div class="flex flex-col items-stretch px-2 pb-2">
              <zen-accordions *ngFor="let cG of ch.checklistGroups">
                <zen-accordion #accordion1 extraClasses="rounded-sm bg-zen mt-px bg-opacity-5">
                  <ng-container head>
                    <div class="flex flex-row items-center justify-between h-12 px-5 btn">
                      <div class="flex flex-row items-center justify-start">
                        <h5 class="text-sm text-zen">{{ extractNameLanguage(cG.name) }}{{cG.isAveraged? " - "
                          +("txtAverage"|translate:language:ModuleNames.Shared):""}}</h5>
                        <div class="flex flex-row items-center px-2 h-10" (click)="$event.stopPropagation()">
                          <z-toggle *ngIf="isOptionalAveraged == true && cG.isAveraged === true" [ngModel]="true"
                            (ngModelChange)="isAveragedChanged($event,ch, cG)"></z-toggle>
                        </div>
                      </div>


                      <div class="btn cancel leading-6 w-6 rounded-md relative h-6">
                        <span class="absolute h-0 border-b border-zen w-3 right-1.5 left-1.5 top-2/4"></span>
                        <span
                          class="absolute h-0 border-b border-zen w-3 right-1.5 left-1.5 top-2/4 transform transition ease-expo"
                          [ngClass]="{'rotate-90': !accordion1.active}"></span>
                      </div>

                    </div>

                  </ng-container>
                  <ng-container body>
                    <div class="flex flex-col items-stretch px-2 pb-2 max-h-56 innerListScroll">
                      <ng-container *ngFor="let cI of cG.checklistItems">
                        <div (click)="surveyClick(ch, cG,cI)" class="flex flex-row items-start justify-start gap-2 text-base py-1 btn">
                          <i class="text-xl w-1/12"
                            [ngClass]="!cI.isChecked?'fa-regular fa-square text-zen':'fa-solid fa-square-check text-exp'"></i>
                          <h5 class="truncate w-11/12 pt0.5">{{ extractNameLanguage(cI.name, true) }}</h5>

                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </zen-accordion>
              </zen-accordions>
            </div>
          </ng-container>
        </zen-accordion>
      </zen-accordions>


      <!-- 
      <mat-expansion-panel class="my-5 shadow-none exp overflow-hidden" [open]="panelOpenState"
        (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header class="expansion-header">
          <mat-panel-title *DemoAccount="i >= 2?'Button':'Default';">
            <mat-checkbox (click)="$event.stopPropagation();" [disabled]="isDemo && i >= 2" class="comment-checkbox"
              [ngModel]="ch.isChecked"
              (ngModelChange)="isDemo &&i >= 2?'':ch.isChecked = $event;isDemo &&i >= 2?'':checklistCheckedChanged($event,ch)">
              {{ extractNameLanguage(ch.name) }}
            </mat-checkbox>
          </mat-panel-title>

        </mat-expansion-panel-header>
        <div *ngIf="panelOpenState" class="container inner bg-white bg-opacity-5 rounded p-3 overflow-hidden"
          [ngClass]="{'pointer-events-none':isDemo && i >= 2}">
          <mat-accordion *ngFor="let cG of ch.checklistGroups">
            <mat-expansion-panel #inner class="my-5 shadow-none bg-white">
              <mat-expansion-panel-header class="expansion-header-inner">
                <mat-panel-title>
                  {{ extractNameLanguage(cG.name) }}
                  {{
                  cG.isAveraged
                  ? " - " +
                  ("txtAverage"
                  | translate : language : ModuleNames.Shared)
                  : ""
                  }}
                </mat-panel-title>
                <div class="flex flex-row items-center px-2 h-10" (click)="$event.stopPropagation()">
                  <z-toggle *ngIf="isOptionalAveraged == true && cG.isAveraged === true" [ngModel]="true"
                    (ngModelChange)="isAveragedChanged($event,ch, cG)"></z-toggle>
                </div>

              </mat-expansion-panel-header>

              <div class="container inner bg-zen bg-opacity-5 rounded p-3" *ngIf="inner.opened">
                <ng-container *ngFor="let cI of cG.checklistItems">
                  <div class="py-2 w-full">
                    <mat-checkbox class="comment-checkbox" [(ngModel)]="cI.isChecked"
                      (ngModelChange)="checklistItemsCheckedChanged($event,ch, cG,cI)">
                      <h3 class="w-48 truncate">{{ extractNameLanguage(cI.name, true) }}</h3>
                    </mat-checkbox>

                  </div>
                </ng-container>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-expansion-panel> -->
    </ng-container>
  </div>
</ng-container>

<!-- <ng-container *ngIf="checklists?.length > 0">

  <ng-container *ngFor="let ch of checklists">

    <button (click)="ch.expanded = !ch.expanded;">{{ch.expanded ? 'collapse' : 'expand'}}</button><mat-checkbox class="comment-checkbox" [(ngModel)]="ch.isChecked" (change)="checklistCheckedChanged($event,ch)">
      {{ extractNameLanguage(ch.name) }}
    </mat-checkbox>
    <br>
    <ng-container *ngIf="ch.expanded">
    <ng-container *ngFor="let cG of ch.checklistGroups">
      <h6 style="margin-left: 70px;">{{ extractNameLanguage(cG.name) }} {{ cG.isAveraged ? ' - Average' : '' }}</h6>
      <br>
      <ng-container *ngFor="let cI of cG.checklistItems">
        <div style="margin-left: 100px;">
          <mat-checkbox class="comment-checkbox" [(ngModel)]="cI.isChecked" (change)="checklistItemsCheckedChanged($event,ch, cG,cI)">
            {{ extractNameLanguage(cI.name) }}
          </mat-checkbox>
        </div>
        <br>
      </ng-container>
    </ng-container>
  </ng-container>


  </ng-container>

</ng-container> -->